"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cafe24Client = void 0;
var lodash_1 = require("lodash");
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var environment_1 = __importDefault(require("../environments/environment"));
var Cafe24Client = /** @class */ (function () {
    function Cafe24Client(api) {
        this.api = api;
    }
    Cafe24Client.instance = function () {
        var api = CAFE24API.init(environment_1.default.cafe24_api_options);
        if (!api)
            throw new Error('CAFE24API is undefined');
        return new Cafe24Client(api);
    };
    Cafe24Client.prototype.dump = function () {
        console.log(this.api);
    };
    Object.defineProperty(Cafe24Client.prototype, "MALL_ID", {
        get: function () { return this.api.MALL_ID; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Cafe24Client.prototype, "SHOP_NO", {
        get: function () { return this.api.SHOP_NO; },
        enumerable: false,
        configurable: true
    });
    Cafe24Client.prototype.get = function (url) {
        var _this = this;
        return new rxjs_1.Observable(function (observer) {
            _this.api.get(url, function (err, res) {
                if (err) {
                    observer.error(err);
                }
                else {
                    observer.next(res);
                    observer.complete();
                }
            });
        });
    };
    Cafe24Client.prototype.getProductInfo = function (prno) {
        var shop_no = this.api.SHOP_NO;
        if (shop_no == 1) {
            return this.get("/api/v2/products/" + prno + "?embed=options,variants").pipe(operators_1.map(function (res) { return res.product; }));
        }
        else {
            return rxjs_1.combineLatest([
                this.get("/api/v2/products/" + prno + "?shop_no=" + shop_no + "&embed=options,variants").pipe(operators_1.map(function (res) { return res.product; })),
                this.get("/api/v2/products/" + prno + "/options?shop_no=1").pipe(operators_1.map(function (res) { return res.options; }))
            ]).pipe(operators_1.map(function (_a) {
                var prod = _a[0], base_shop_options = _a[1];
                if (prod.options.has_option) {
                    lodash_1.each(lodash_1.zip(prod.options.options, base_shop_options.options), function (_a) {
                        var pOption = _a[0], bOption = _a[1];
                        if (pOption && bOption) {
                            pOption.option_name_alias = bOption.option_name;
                            lodash_1.each(lodash_1.zip(pOption.option_value, bOption.option_value), function (_a) {
                                var pValue = _a[0], bValue = _a[1];
                                if (pValue && bValue) {
                                    pValue.option_text_alias = bValue.option_text;
                                }
                            });
                        }
                    });
                }
                return prod;
            }));
        }
    };
    return Cafe24Client;
}());
exports.Cafe24Client = Cafe24Client;
